import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  fetchActiveMemberData,
  fetchTaskByCustomId,
} from "../../../../Redux/Slice/TaskMasterSlice";
import Loader from "../../../../Components/Loader/Loader";

const ShowMianTaskDetails = () => {
  const formatDate = (isoDate) => {
    if (!isoDate) return "";
    const date = new Date(isoDate);
    return `${date.getDate().toString().padStart(2, "0")}/${(
      date.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}/${date.getFullYear()}`;
  };

  const loginData = Cookies.get("loginData");
  const parsedData = loginData ? JSON.parse(loginData) : null;

  const dispatch = useDispatch();
  const { id } = useParams();

  const { TaskByCustomIdData, loading: taskLoading } = useSelector((state) => state.TaskMaster);
  const [isInitialLoading, setIsInitialLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      setIsInitialLoading(true);
      try {
        await Promise.all([
          dispatch(fetchTaskByCustomId(id)),
          dispatch(fetchActiveMemberData())
        ]);
      } finally {
        setIsInitialLoading(false);
      }
    };
    loadData();
  }, [dispatch, id]);

  // Show loader during initial data loading
  if (isInitialLoading || taskLoading || !TaskByCustomIdData) {
    return <Loader />;
  }

  // Get data based on user role
  const getDataForRole = () => {
    const role = parsedData?.data?.Role;
    if (role === "owner") {
      return {
        remark: TaskByCustomIdData?.data?.Remark || "",
        assignDate: TaskByCustomIdData?.data?.AssignDate || "",
        assignedBy: TaskByCustomIdData?.data?.AssignedBy?.Name || "",
        companyName: TaskByCustomIdData?.data?.CompanyId?.CompanyName || "",
        dueDate: TaskByCustomIdData?.data?.DueDate || "",
        description: TaskByCustomIdData?.data?.TaskId?.Description || "",
        project: TaskByCustomIdData?.data1?.Project?.project_name || "",
        taskName: TaskByCustomIdData?.data1?.TastName || ""
      };
    } else {
      return {
        remark: TaskByCustomIdData?.data?.Remark || "",
        assignDate: TaskByCustomIdData?.data?.AssignDate || "",
        assignedBy: TaskByCustomIdData?.data?.AssignedBy?.Name || "",
        companyName: TaskByCustomIdData?.data?.CompanyId?.CompanyName || "",
        dueDate: TaskByCustomIdData?.data?.DueDate || "",
        description: TaskByCustomIdData?.data1?.Description || "",
        project: TaskByCustomIdData?.data1?.Project?.project_name || "",
        taskName: TaskByCustomIdData?.data1?.TastName || ""
      };
    }
  };

  const formData = getDataForRole();

  return (
    <>
      <div className="p-1 sm:p-2 bg-gray-100 min-h-screen">

        <h3 className="text-2xl font-bold main_title_page text-white px-4 py-2 mb-6 inline-block rounded">
          Main Task Details
        </h3>
        <div className="bg-white shadow rounded-xl p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Remark */}
            <div>
              <label className="text-base font-semibold text-black uppercase mb-1 block">
                Remark
              </label>
              <input
                type="text"
                value={formData.remark}
                readOnly
                className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-800 focus:outline-none"
              />
            </div>

            {/* Assign Date */}
            <div>
              <label className="text-base font-semibold text-black uppercase mb-1 block">
                Assign Date
              </label>
              <input
                type="text"
                value={formatDate(formData.assignDate)}
                readOnly
                className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-800 focus:outline-none"
              />
            </div>

            {/* Assigned By */}
            <div>
              <label className="text-base font-semibold text-black uppercase mb-1 block">
                Assigned By
              </label>
              <input
                type="text"
                value={formData.assignedBy}
                readOnly
                className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-800 focus:outline-none"
              />
            </div>

            {/* Company Name */}
            <div>
              <label className="text-base font-semibold text-black uppercase mb-1 block">
                Company Name
              </label>
              <input
                type="text"
                value={formData.companyName}
                readOnly
                className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-800 focus:outline-none"
              />
            </div>

            {/* Due Date */}
            <div>
              <label className="text-base font-semibold text-black uppercase mb-1 block">
                Due Date
              </label>
              <input
                type="text"
                value={formatDate(formData.dueDate)}
                readOnly
                className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-800 focus:outline-none"
              />
            </div>

            {/* Description  */}
            <div className="md:col-span-2">
              <label className="text-base font-semibold text-black uppercase mb-1 block">
                Description
              </label>
              <textarea
                value={formData.description}
                readOnly
                className="w-full  px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-800 focus:outline-none"
                style={{ height: "auto" }}
              />
            </div>

            {/* Project */}
            <div>
              <label className="text-base font-semibold text-black uppercase mb-1 block">
                Project
              </label>
              <input
                type="text"
                value={formData.project}
                readOnly
                className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-800 focus:outline-none"
              />
            </div>

            {/* Task Name */}
            <div>
              <label className="text-base font-semibold text-black uppercase mb-1 block">
                Task Name
              </label>
              <input
                type="text"
                value={formData.taskName}
                readOnly
                className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-800 focus:outline-none"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShowMianTaskDetails;